"use strict";

var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _forEachInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/for-each");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs3/core-js-stable/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.variants = exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _merge = _interopRequireDefault(require("lodash/merge"));
var _theme = _interopRequireDefault(require("@chakra-ui/theme"));
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var baseStyle = {
  px: 8,
  py: 3,
  fontSize: 'base',
  fontFamily: 'body',
  lineHeight: 0.875,
  fontWeight: 'semibold',
  borderWidth: '1px',
  borderStyle: 'solid',
  borderRadius: '1.25rem',
  textTransform: 'capitalize',
  transition: 'all normal ease',
  _disabled: {
    cursor: 'not-allowed',
    opacity: 1,
    bg: 'gray.medium',
    borderColor: 'gray.medium',
    color: 'gray.dark'
  },
  '& svg': {
    display: 'block'
  }
};
// TODO: We need an active styling
var disabledButtonHoverStyle = {
  _disabled: {
    bg: 'gray.medium',
    borderColor: 'gray.medium',
    color: 'gray.dark'
  }
};
var destructiveButtonStyles = {
  bg: 'white',
  borderColor: 'red.default',
  color: 'red.default',
  _hover: _objectSpread({
    borderColor: 'red.800',
    color: 'red.800'
  }, disabledButtonHoverStyle)
};
var variants = exports.variants = {
  primary: {
    bg: 'primary.default',
    borderColor: 'primary.default',
    color: 'white',
    _hover: _objectSpread({
      bg: 'primary.600',
      borderColor: 'primary.600',
      color: 'white'
    }, disabledButtonHoverStyle)
  },
  primaryOnDark: {
    bg: 'yellow.default',
    borderColor: 'yellow.default',
    color: 'black',
    _hover: _objectSpread({
      bg: 'yellow.500',
      borderColor: 'yellow.500',
      color: 'black'
    }, disabledButtonHoverStyle),
    _focus: {
      boxShadow: '0 0 0 3px rgba(255, 255, 255, 0.7)'
    }
  },
  secondary: {
    bg: 'white',
    borderColor: 'gray.medium',
    color: 'primary.default',
    _hover: _objectSpread({
      borderColor: 'primary.600',
      color: 'primary.600'
    }, disabledButtonHoverStyle)
  },
  secondaryOnDark: {
    bg: 'none',
    borderColor: 'white',
    color: 'white',
    _hover: _objectSpread({
      bg: 'white',
      borderColor: 'white',
      color: 'black'
    }, disabledButtonHoverStyle),
    _focus: {
      boxShadow: '0 0 0 3px rgba(255, 255, 255, 0.7)'
    }
  },
  tertiary: {
    bg: 'none',
    borderWidth: 'none',
    borderRadius: 'unset',
    color: 'primary.default',
    h: 'unset',
    m: 'unset',
    minW: 'unset',
    p: 'unset',
    lineHeight: 1,
    _disabled: {
      bg: 'none',
      color: 'gray.dark'
    },
    _hover: {
      color: 'primary.600',
      _disabled: {
        color: 'gray.dark'
      }
    },
    _active: {
      color: 'primary.600',
      _disabled: {
        color: 'gray.dark'
      }
    }
  },
  tertiaryOnDark: {
    bg: 'none',
    borderRadius: 'unset',
    borderWidth: 'none',
    color: 'white',
    h: 'unset',
    m: 'unset',
    minW: 'unset',
    p: 'unset',
    _disabled: {
      bg: 'none',
      color: 'white',
      opacity: '.7'
    },
    _hover: {
      color: 'white',
      opacity: '.8',
      _disabled: {
        opacity: '.7'
      }
    }
  },
  destructive: _objectSpread({}, destructiveButtonStyles),
  destructiveOnDark: _objectSpread({}, destructiveButtonStyles)
};
var defaultProps = {
  size: null
};
var _default = exports["default"] = (0, _merge["default"])(_theme["default"].components.Button, {
  variants: variants,
  baseStyle: baseStyle,
  defaultProps: defaultProps
});